import React from 'react';
import { Select } from 'antd';
const Option = Select.Option;

const defaultLayout = { style: { margin: 0 }, labelCol: { xs: { span: 24 }, sm: { span: 8 } }, wrapperCol: { xs: { span: 24 }, sm: { span: 16 } } };

const Common = [[
    { code: "te", span: 8 },
    { code: "alwBlk", span: 3 },
    { code: "isDis", span: 3 },
    { code: "isRead", span: 3 },
    { code: "isHdn", span: 3 },
    { code: "isLbl", span: 3 }
], [
    { code: "c", span: 8 },
    { code: "cId", span: 8 },
    { code: "lblAlg", span: 8 }
], [
    { code: "lblW", span: 8 },
    { code: "ctlW", span: 8 },
    { code: "ctlH", span: 8 }
]];
const EditorDesc = {
    // 通用控件描述
    Common: Common,
    // 文本控件描述
    TextEidtor: [[
        { ctlName: "Input", te: "文本后信息", code: "bdText", span: 8, layout: defaultLayout },
        { ctlName: "Input", te: "初始值", code: "defVal10", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "InputNumber", te: "最小长度", code: "minL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "InputNumber", te: "最大长度", code: "maxL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }
    ], [
        { ctlName: "InputNumber", te: "最小值", code: "minV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "InputNumber", te: "最大值", code: "maxV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]],
    // 数字控件描述
    NumberEidtor: [[
        { ctlName: "InputNumber", te: "最小值", code: "minV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "InputNumber", te: "最大值", code: "maxV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }
    ], [
        { ctlName: "InputNumber", te: "最小长度", code: "minL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "InputNumber", te: "最大长度", code: "maxL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]],
    // 时间控件描述
    TimeEidtor: [[
        { ctlName: "InputNumber", te: "小时选项间隔", code: "hourStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "InputNumber", te: "分钟选项间隔", code: "minuteStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }
    ], [
        { ctlName: "InputNumber", te: "秒选项间隔", code: "secondStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } },
        { ctlName: "Input", te: "时间格式", code: "timeFmt", span: 8, layout: defaultLayout, props: { placeholder: "HH:mm:ss" } }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]],
    // 日期控件描述
    DateEidtor: [[
        {
            ctlName: "Select", te: "组件模式", code: "ctlMode", span: 8, layout: defaultLayout, props: { placeholder: "YYYY-MM-DD", defaultValue: "date" }, children: [
                <Option value="date">日期模式</Option>,
                <Option value="dateTime">日期时间模式</Option>,
                <Option value="month">月模式</Option>,
                <Option value="week">周模式</Option>,
                <Option value="dateRange">日期范围模式</Option>,
                <Option value="dateTimeRange">日期时间范围模式</Option>]
        },
        { ctlName: "Input", te: "日期格式", code: "dateFmt", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "DatePicker", te: "可选的起始日期", code: "optBDt", span: 8, layout: defaultLayout },
        { ctlName: "DatePicker", te: "可选的结束日期", code: "optEDt", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]],
    // 下拉窗控件描述
    ComboxEidtor: [[
        { ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout },
        { ctlName: "Checkbox", te: "多选", code: "mulSel", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "Checkbox", te: "自动选择", code: "autoSel", span: 8, layout: defaultLayout },
        { ctlName: "Checkbox", te: "搜索框", code: "search", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]],
    // 复选框组件描述
    CheckboxGroupEidtor: [[
        { ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout },
        { ctlName: "Input", te: "默认选中项", code: "checked", span: 8, layout: defaultLayout }
    ]],
    // 复选框控件描述
    CheckboxEidtor: [[
        { ctlName: "Input", te: "初始值", code: "defVal10", span: 8, layout: defaultLayout }
    ]],
    // 下拉树控件描述
    ComboxTreeEidtor: [[
        { ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout },
        { ctlName: "Checkbox", te: "多选", code: "mulSel", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "Input", te: "显示属性名", code: "showKey", span: 8, layout: defaultLayout },
        { ctlName: "Input", te: "保存属性名", code: "saveKey", span: 8, layout: defaultLayout }
    ], [
        { ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }
    ]]
};
// 兼容老版本类型
EditorDesc.EP_EO_UI_3101 = EditorDesc.TextEidtor;
EditorDesc.EP_EO_UI_3104 = EditorDesc.NumberEidtor;
EditorDesc.EP_EO_UI_3105 = EditorDesc.TimeEidtor;
EditorDesc.EP_EO_UI_3106 = EditorDesc.DateEidtor;
EditorDesc.EP_EO_UI_3107 = EditorDesc.ComboxEidtor;
EditorDesc.EP_EO_UI_3108 = EditorDesc.CheckboxGroupEidtor;
EditorDesc.EP_EO_UI_3109 = EditorDesc.CheckboxGroupEidtor;
EditorDesc.EP_EO_UI_3110 = EditorDesc.CheckboxEidtor;
EditorDesc.EP_EO_NUI_0001 = EditorDesc.ComboxTreeEidtor;


export {
    EditorDesc
};


// WEBPACK FOOTER //
// ./apps/pages/paramMng/editorConstants.js